var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header'),_vm._v(" "),_c('Error',{attrs:{"err-code":_vm.error.statusCode,"text":_vm.error.message}}),_vm._v(" "),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }